import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "./authSlice";

// -------------------FETCH PROVIDERS GALLERY LIST------------------
export const fetchProviderList = createAsyncThunk(
  "provider-gallery/fetchProviderList",
  async ({ page = 1, country_id = "" } = {}, { rejectWithValue }) => {
    try {
      //   console.log("Calling API...");
      const response = await axiosInstance.get(
        `/admin/service-provider-gallery/list-image?page=${page}&country_id=${country_id}`
      );
      //   console.log("API response:", response.data.data.sPImageGalleryData);
      return response.data;
    } catch (error) {
      //   console.log("API error:", error);
      return rejectWithValue(
        error.response?.data || "Error fetching provider list"
      );
    }
  }
);
// --------------------FECTH AND UPDATE PROVIDERS STATUS----------------
export const UpdateProviderStatus = createAsyncThunk(
  "provider-gallery/UpdateProviderStatus",
  async ({ provider_image_gallery_id }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/admin/service-provider-gallery/image-status-update",
        {
          provider_image_gallery_id: provider_image_gallery_id,
          is_confirmed: 1,
        }
      );
      //   console.log("The response of status update is :", response.data);
      return {
        provider_image_gallery_id: response.data.data.provider_image_gallery_id,
        is_confirmed: response.data.data.new_status,
      };
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error Updating Status");
    }
  }
);

// ---------------------DELETE PROVIDER DETAIL ---------------------------------
export const DeleteProviderDetails = createAsyncThunk(
  "provider-gallery/DeleteProviderDetails",
  async ({ provider_image_gallery_id }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/admin/service-provider-gallery/delete-image",
        {
          provider_image_gallery_id: provider_image_gallery_id,
          is_confirmed: 1,
        }
      );
      //   console.log("The response of delete provider is :", response.data); // ✅ now works
      return provider_image_gallery_id; // return id for reducer to remove
    } catch (err) {
      return rejectWithValue(
        err.response?.data || "Error while deleting details"
      );
    }
  }
);

// ----------------------Fetching country ----------------------------
export const fetchCountry = createAsyncThunk(
  "provider-gallery/fetchCountry",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get("/get-country");
      //   console.log("The res for country is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.res?.data || "Error fetching country");
    }
  }
);

// -----------------GET PRIORITY ---------------------------------------
export const fetchProviderPriority = createAsyncThunk(
  "provider-gallery/fetchProviderPriority",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        "/admin/service-provider-gallery/get-priority"
      );
      //   console.log("Providers priority response is :", response.data.data.priorities);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || "Error fetching providers priority"
      );
    }
  }
);

// ---------------------ADD OR UPDATE PROVIDER IMAGE-------------------------
export const addOrUpdateProviderImage = createAsyncThunk(
  "provider-gallery/addOrUpdateProviderImage",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/admin/service-provider-gallery/add-or-update-image",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      //   console.log("Backend response:", response.data); // <--- ADD THIS
      return response.data.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || "Error adding/updating image"
      );
    }
  }
);

// -----------------------GET PROVIDER DETAIL BY ID-------------------------
export const getProviderDetailById = createAsyncThunk(
  "provider-gallery/getProviderDetailById",
  async (provider_image_gallery_id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/admin/service-provider-gallery/get-image",
        { provider_image_gallery_id }
      );

      //   console.log("The res of get by id is :", response.data);
      return response.data.data; // <-- important, not the whole response
    } catch (err) {
      return rejectWithValue(
        err.response?.data || "Error while fetching provider detail by Id"
      );
    }
  }
);

const ProvidergalSlice = createSlice({
  name: "providerGallery",
  initialState: {
    List: [],
    providerList: [],
    countryList: [],
    providerPriolist: [],
    providerlistById: [],
    deleteprovider: null,
    loading: false,
    error: null,
    currentPage: 1,
    totalPages: 1,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // For fetching proboder gallery list
      .addCase(fetchProviderList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchProviderList.fulfilled, (state, action) => {
        state.loading = false;
        state.providerList = action.payload.data.sPImageGalleryData || [];
        state.currentPage = action.payload.data.current_page || 1;
        state.totalPages = action.payload.data.total_pages || 1;
      })

      .addCase(fetchProviderList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //   For updating status
      .addCase(UpdateProviderStatus.fulfilled, (state, action) => {
        const index = state.providerList.findIndex(
          (item) => item.id === action.payload.provider_image_gallery_id
        );
        if (index !== -1) {
          state.providerList[index].status = action.payload.status;
        }
      })

      //   For delete provider details
      .addCase(DeleteProviderDetails.fulfilled, (state, action) => {
        state.providerList = state.providerList.filter(
          (item) => item.id !== action.payload
        );
      })
      //   For country
      .addCase(fetchCountry.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCountry.fulfilled, (state, action) => {
        state.loading = false;
        state.countryList = action.payload.data || [];
      })
      .addCase(fetchCountry.rejected, (state, action) => {
        (state.loading = false), (state.error = action.payload);
      })
      //   For getting priority
      .addCase(fetchProviderPriority.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchProviderPriority.fulfilled, (state, action) => {
        state.loading = false;
        state.providerPriolist = action.payload.data?.priorities;
      })
      .addCase(fetchProviderPriority.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //   for add and update
      .addCase(addOrUpdateProviderImage.fulfilled, (state, action) => {
        const updatedItem = action.payload;
        const index = state.providerList.findIndex(
          (item) => item.id === updatedItem.provider_image_gallery_id
        );

        if (index !== -1) {
          // Update existing item
          state.providerList[index] = updatedItem;
        } else {
          // Add new item
          state.providerList.unshift(updatedItem);
        }
      })
      .addCase(addOrUpdateProviderImage.rejected, (state, action) => {
        state.error = action.payload;
      })
      //   For getting provider list by id
      .addCase(getProviderDetailById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProviderDetailById.fulfilled, (state, action) => {
        state.loading = false;
        state.providerlistById = action.payload; // should now be the provider object
        console.log("Fetched provider detail:", action.payload);
      })
      .addCase(getProviderDetailById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default ProvidergalSlice.reducer;
